import { Checkbox, CircularProgress, Divider, List } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import {
  selectAllDevices,
  selectDevice
} from "../../../../state/ducks/devices/operations";
import { DeviceApp } from "../../../../state/ducks/devices/types";
import { localized } from "../../../../state/i18n/i18n";
import { AppState } from "../../../../state/store";
import { GetColorByIndex } from "../../../../utilities/colors";
import DeviceMenuItem from "./device-menu-item";
import "./device-menu.scss";

const mapStateToProps = (state: AppState) => {
  return {
    devices: state.devicesReducer.devices,
    pending: state.devicesReducer.pending,
    selectedAll: state.devicesReducer.selectedAll,
    retrivalStatus: state.devicesReducer.devicesRetrivalFailed,
    emptyListStatus: state.devicesReducer.receivedEmptyList, 
  };
};
const mapDispatchToProps = (dispatch: Dispatch) => ({
  selectDevice: async (idenitifier: string) =>
    (await selectDevice(idenitifier))(dispatch),
  selectAllDevices: () => selectAllDevices()(dispatch),
});

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

class DeviceMenu extends React.PureComponent<Props> {
  public render() {
    return (
      <div>
        {this.showDeviceMenuTopContainer()}
        <Divider />
        <div className="chooseAllOrDismissContainer">
          <div className="chooseAllOrDismiss">
            {localized("ChooseOrDismissAll")}
          </div>
          <Checkbox
            onClick={this.props.selectAllDevices}
            color={"primary"}
            className="checkBoxStyle"
            checked={this.props.selectedAll}
          />
        </div>
        <Divider />
        <div className="deviceOverflow">
          {<List className="devicesSelect">{this.mapDevices()}</List>}
          
          {this.props.pending && <CircularProgress className="spinnerDevice" />}
         
        </div>
      </div>
    );
  }

  private showDeviceMenuTopContainer = () => (
    <div className={"topContainer devicesTableTopContainer"}>
      <div className="width100">
        <div className="boldText">{localized("Devices")}</div>
        <div className="availableDevices">{localized("AvailableDevices")}</div>
      </div>
    </div>
  );

  private mapDevices = () => {
    if (this.props.devices.length > 0) {
      return this.props.devices.map(this.showDeviceMenuItems);
    } else if (this.props.retrivalStatus === false && this.props.emptyListStatus === false) {
      return (
        <div className="emptyMessageSettings">{localized("LoadingDevices")}</div>
      );
    } else
      return (
        <div className="emptyMessageSettings">{localized("NoDevices")}</div>
      );
  };

  private showDeviceMenuItems = (d: DeviceApp, index: number) => (
    <DeviceMenuItem
      onMenuItemClicked={this.props.selectDevice}
      checkBoxColor={GetColorByIndex(index)}
      selected={d.selected}
      name={d.displayName ?? "" }
      active={d.active}
      key={d.deviceId}
      identifier={d.deviceId}
      />
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(DeviceMenu);
